import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FieldTextarea, FieldWrapper, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { analytics } from 'app/utils/segment';
import styles from './transferToAgentModal.module.scss';
import UserItem from './userItem';
export default class TransferToAgentModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onAssistedTransferClick = (payload) => {
            const { requestToUser } = payload;
            if (requestToUser !== undefined) {
                this._sendAssistedTransferRequest(payload);
            }
            else {
                console.warn('onAssistedTransferClick no valid user given on payload: ', requestToUser);
            }
        };
        this.onBlindTransferClick = (payload) => {
            const { metaConversation, transferToAgentShowMessageModal } = this.props;
            const { requestToUser } = payload;
            const { id } = metaConversation.conversation;
            if (requestToUser !== undefined) {
                if (id) {
                    analytics.conversationTransferred({
                        conversationId: id,
                        option: 'agent',
                    });
                }
                this.setState({ blindRequestToUser: requestToUser });
                transferToAgentShowMessageModal();
            }
            else {
                console.warn('onBlindTransferClick no valid user given on payload: ', requestToUser);
            }
        };
        this.onBlindTransferMessageClick = () => {
            const requestToUser = this.state.blindRequestToUser;
            if (requestToUser) {
                this._sendBlindTransferRequest({ requestToUser: requestToUser });
            }
            else {
                console.warn('onBlindTransferMessageClick no valid user given on state: ', requestToUser);
            }
        };
        this._sendBlindTransferRequest = (payload) => {
            const { requestToUser } = payload;
            const { messageValue } = this.state;
            const csid = this.props.metaConversation.conversation.id;
            const blindTransferRequest = {
                requestToUser: requestToUser,
                requestFromAgent: this.props.profile,
                metaConversation: this.props.metaConversation,
                message: messageValue,
            };
            this.props
                .transferToAgentBlindRequest(blindTransferRequest)
                .then((response) => {
                this.props.transferToAgentModalClose();
                this.props.transferToAgentHideMessageModal();
            })
                .catch((exception) => {
                console.warn(exception);
                this.props.transferRequestStop(csid);
                this.props.transferToAgentModalClose();
                const options = {
                    title: 'Could not transfer the conversation',
                    text: `An issue occurred while trying transfer conversation ${csid}.`,
                    className: 'danger',
                    icon: 'i-exclamation',
                };
                this.props.notificationAdd(options);
            });
        };
        this._sendAssistedTransferRequest = (payload) => {
            const { requestToUser } = payload;
            this.props.transferToAgentAssistedRequest({
                requestToUser: requestToUser,
                requestFromAgent: this.props.profile,
                metaConversation: this.props.metaConversation,
            });
        };
        this.hideTransferToAgentModal = () => {
            this.props.transferToAgentModalClose();
        };
        this.hideTransferToAgentModalMessageModal = () => {
            this.props.transferToAgentModalClose();
            this.props.transferToAgentHideMessageModal();
        };
        this.onChangeInput = (e) => {
            this.setState({ init: false, searchValue: e.target.value });
        };
        this.onChangeMessageValue = (e) => {
            this.setState({ messageValue: e.target.value });
        };
        this.focusOnSearchInput = () => {
            setTimeout(() => {
                if (this.input.current) {
                    this.input.current.focus();
                }
            }, 100);
        };
        this.focusOnMessageInput = () => {
            setTimeout(() => {
                if (this.messageInput && this.messageInput.current) {
                    this.messageInput.current.focus();
                }
            }, 100);
        };
        this.input = React.createRef();
        this.messageInput = React.createRef();
        this.state = {
            init: true,
            searchValue: '',
            messageValue: '',
            blindRequestToUser: null,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { ui: { isModalShown, isMessageModalShown }, } = this.props;
        const { ui: { isModalShown: nextIsModalShown, isMessageModalShown: nextIsMessageModalShown, }, } = nextProps;
        if (isModalShown && !nextIsModalShown) {
            // modal closing
            this.setState({
                init: true,
                searchValue: '',
                blindRequestToUser: null,
            });
        }
        if (isMessageModalShown && !nextIsMessageModalShown) {
            this.setState({
                messageValue: '',
            });
        }
        else if (!isModalShown && nextIsModalShown) {
            // modal opening
            this.focusOnSearchInput();
        }
        else if (!isMessageModalShown && nextIsMessageModalShown) {
            this.focusOnMessageInput();
        }
    }
    render() {
        const { onlinePresence, meta, metaConversation, numberTransferRequests, profile, transferToAgentRequests, ui, } = this.props;
        const { searchValue } = this.state;
        const disabled = meta.requestAssistedTransfer === 'loading';
        let csid = '';
        let loading = null;
        const searchValueTrimmed = searchValue.trim();
        const filteredPresence = onlinePresence.filter((presenceUser) => {
            const { user } = presenceUser;
            let matchesNameOrNoName = !searchValueTrimmed;
            if (searchValueTrimmed) {
                if (user.name !== undefined && user.name !== null) {
                    const matchingName = user.name.toUpperCase();
                    matchesNameOrNoName =
                        matchingName.indexOf(searchValue.toUpperCase()) !== -1;
                }
            }
            return user.id !== profile.id && matchesNameOrNoName;
        });
        if (metaConversation !== null &&
            metaConversation.conversation.id !== null) {
            csid = metaConversation.conversation.id;
        }
        const listAgent = (presenceUser, index) => {
            const { user, presence } = presenceUser;
            return (_jsx(UserItem, { user: user, disabled: disabled, metaConversation: metaConversation, highlighted: false, asyncStatus: meta.requestAssistedTransfer, isAgent: true, presence: presence, onAssistedTransferClick: this.onAssistedTransferClick, onBlindTransferClick: this.onBlindTransferClick, numberTransferRequests: numberTransferRequests, transferToAgentRequests: transferToAgentRequests }, user.id));
        };
        if (filteredPresence.length === 0 && this.state.init === false) {
            loading = (_jsx("div", Object.assign({ className: "row-item empty-list text-center" }, { children: "No agent found" })));
        }
        else if (filteredPresence.length === 0 && this.state.init === true) {
            loading = (_jsx("div", Object.assign({ className: "row-item empty-list text-center" }, { children: "Type a name to search for an agent" })));
        }
        return (_jsxs("div", { children: [_jsxs(Modal, Object.assign({ isOpen: ui.isModalShown, onClose: this.hideTransferToAgentModal }, { children: [_jsx(ModalHead, { title: `Transfer #${csid} to a different agent`, onClose: this.hideTransferToAgentModal }), _jsx(ModalBody, { children: _jsxs("div", Object.assign({ className: styles.body }, { children: [_jsx(FieldText, { input: {
                                            name: 'search',
                                            value: searchValue,
                                            onChange: this.onChangeInput,
                                        }, placeholder: "Search online agents...", disabled: disabled, label: "Search online agents" }), _jsxs(FieldWrapper, Object.assign({ label: "Select an agent", noAlert: true }, { children: [filteredPresence.map(listAgent), loading] }))] })) }), _jsx(ModalFoot, { cancelOnClick: this.hideTransferToAgentModal })] })), _jsxs(Modal, Object.assign({ isOpen: ui.isMessageModalShown, onClose: this.hideTransferToAgentModalMessageModal }, { children: [_jsx(ModalHead, { title: `Transfer #${csid} to a different agent`, onClose: this.hideTransferToAgentModalMessageModal }), _jsx(ModalBody, { children: _jsx("div", Object.assign({ className: styles.bodyMessage }, { children: _jsx(FieldTextarea, { input: {
                                        name: 'message',
                                        value: this.state.messageValue,
                                        onChange: this.onChangeMessageValue,
                                    }, label: "Message", placeholder: "Write a message..." }) })) }), _jsx(ModalFoot, { confirmOnClick: this.onBlindTransferMessageClick, confirmName: "Transfer", cancelOnClick: this.hideTransferToAgentModalMessageModal, cancelName: "Cancel transfer" })] }))] }));
    }
}
